import Default from './default.svg';

export default Default;
export { default as audio } from './audio.svg';
export { default as gadzhety } from './gadzhety.svg';
export { default as aksessuary } from './aksessuary.svg';
export { default as tsifrovye } from './tsifrovye.svg';
export { default as telefony } from './telefony.svg';
export { default as modemy } from './modemy.svg';
export { default as planshety } from './planshety.svg';
export { default as actions } from './actions.svg';
export { default as merch } from './merch.svg';
export { default as computers } from './computers.svg';
export { default as tovaryDliaDoma } from './tovary-dlia-doma.svg';
export { default as kompiuternaiaTekhnika } from './kompiuternaia-tekhnika.svg';
export { default as smartHome } from './smart-home.svg';
